import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-waiting',
  templateUrl: 'rmt-waiting.html'
})
export class RmtWaitingComponent {
  @Input() options;
  @Input() msg: string ='';
  @Input() width: number;
  @Input() height: number;
  
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/rmt-waiting/rmt-waiting.ts